module.exports = "<div class=\"loader_p\" title=\"Processing Data\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1885384336/src/src/app/common/api-progressing/api-progressing.component.html
// module id = ../../../../../src/app/common/api-progressing/api-progressing.component.html
// module chunks = main